// A users/{uid} document holds ONE card, in the singular `cardNumber` field. The cardNumbers array
// is gone and is NOT read — accounts the old migration left array-shaped are migrated back by hand.
// Pure and provider-free so it can be tested without loading the Firebase SDK.

export const CARD_NUMBER_FIELD = "cardNumber";

/** The cardholder's card, or null when the document names none. */
export function readCardNumber(
  data: Record<string, unknown> | undefined,
): string | null {
  const raw = data?.[CARD_NUMBER_FIELD];
  const card = typeof raw === "string" ? raw.replace(/\s+/g, "") : "";
  return card || null;
}
